import { WebPushNotificationsOptions } from 'owa-outlook-service-options';
import { default as registerWebPushServiceWorker } from './registerWebPushServiceWorker';
import { default as loadWebPushSubscriptions } from './services/loadWebPushSubscriptions';
import { default as subscribe } from './subscribe';
import { default as registerEndpoint } from './services/registerEndpoint';
import { getClientId } from 'owa-config';
import { trace } from 'owa-trace';

export default async function enableWebPushNotifications(
    webPushNotificationsOption: WebPushNotificationsOptions,
    windowObj: Window
): Promise<boolean> {
    let serviceWorkerRegistration: ServiceWorkerRegistration = await registerWebPushServiceWorker(
        windowObj
    );
    let subscription = await serviceWorkerRegistration.pushManager.getSubscription();
    let enabled: boolean = false;
    if (subscription == null) {
        enabled = await subscribe(serviceWorkerRegistration, webPushNotificationsOption, windowObj);
    } else {
        let serverSubscriptions = await loadWebPushSubscriptions();
        let alreadyRegistered = false;
        for (let i = 0; i < serverSubscriptions.length; ++i) {
            if (serverSubscriptions[i].endpoint == subscription.endpoint) {
                alreadyRegistered = true;
                break;
            }
        }

        if (alreadyRegistered) {
            // Renew the subsription with server
            let json: any = subscription.toJSON();
            json.clientId = getClientId();
            await registerEndpoint(json);
            enabled = true;
        } else {
            trace.warn('[WebPush] Orphaned subsciption found, unsubscribing.');
            let unsubscribed = await subscription.unsubscribe();
            if (unsubscribed) {
                enabled = await subscribe(
                    serviceWorkerRegistration,
                    webPushNotificationsOption,
                    windowObj
                );
            } else {
                trace.warn('[WebPush] Failed to unsubscribe.');
            }
        }
    }

    return enabled;
}
